/**
 * Spinner Component
 * Generic loading spinner for async operations
 */

import React from 'react';
import './Spinner.css';

const Spinner = ({ size = 'medium', color = '#8B5CF6', className = '' }) => {
  const sizeMap = {
    small: '20px',
    medium: '40px',
    large: '60px',
  };

  const spinnerSize = sizeMap[size] || size;

  return (
    <div className={`spinner-container ${className}`}>
      <div
        className="spinner"
        style={{
          width: spinnerSize,
          height: spinnerSize,
          borderTopColor: color,
        }}
      />
    </div>
  );
};

export default Spinner;
